import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import { RouteHandler, Link } from "react-router";
import Select from "react-select";
import ScrollMixin from "../../../../utils/mixins/onScroll";

const options = [
    {value: "/legal/tos", label: "Terms of service"},
    {value: "/legal/privacy", label: "Privacy"},
    {value: "/legal/return-policy", label: "Return & refund policy"},
    {value: "/legal/warranty", label: "Limited warranty"},
    {value: "/legal/trademark", label: "Trademark usage & policy"},
    {value: "/legal/compliance", label: "FCC compliance"},
    {value: "/legal/open", label: "Open source compliance"},
];

let Legal = React.createClass({
    mixins: [ScrollMixin],
    getInitialState() {
        return {
            scrolledTop: false,
            scrolledBottom: false
        };
    },
    componentDidMount(){
        window.scrollY = 0;
        this.setState({
            current: this.app.router.getCurrentPathname()
        });
    },
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Legal";
        }
    },
    handleSelect(route){
        this.setState({
            current: route
        });
        this.refs.content.getDOMNode().focus();
        this.app.router.transitionTo(route, null, this.props.query);
    },
    handleBackToTop(){
        window.scrollY = 0;
    },
    onScroll() {
        let newState = {
            scrolledTop: document.body.scrollTop >= 300,
            scrolledBottom: document.body.scrollHeight - document.body.scrollTop <= 840
        };

        if (this.state.scrolledTop !== newState.scrolledTop || this.state.scrolledBottom !== newState.scrolledBottom) {
            this.setState(newState);
        }
    },
    render() {
        return (
            <section className={["eo-view legal", (this.state.scrolledTop ? "scrolled-top" : ""),
            (this.state.scrolledBottom ? "scrolled-bottom" : "")].join(" ")}>
                <Hero className="legal-hero small">
                    <h1>Legalese</h1>

                </Hero>

                <nav className="legal-dropdown grid-3 grid-s-10">
                    <div className="eo-validated-input">
                        <Select
                            className="eo-select no-clear"
                            onChange={this.handleSelect}
                            options={options}
                            ref="dropdown"
                            value={this.state.current}
                            searchable={false}
                            clearable={false}/>
                    </div>
                </nav>
                <nav id="legal-nav" className="legal-nav grid-3 grid-s-10">
                    <Link className="legal-nav-item" to="tos">Terms of service</Link>
                    <Link className="legal-nav-item" to="privacy">Privacy</Link>
                    <Link className="legal-nav-item" to="return-policy">Return &amp; refund policy</Link>
                    <Link className="legal-nav-item" to="warranty">Limited warranty</Link>
                    <Link className="legal-nav-item" to="trademark">Trademark usage &amp; policy</Link>
                    <Link className="legal-nav-item" to="compliance">FCC compliance</Link>
                    <Link className="legal-nav-item" to="open">Open source compliance</Link>
                </nav>
                <section ref="content" className="legal-content grid-7 grid-s-10">
                    <RouteHandler/>
                    <div className="back-to-top">
                        <a className="top-link eo-btn-outline hover-blue" href='#' onClick={this.handleBackToTop}>Back to top</a>
                    </div>
                </section>
            </section>
        );
    }
});

export default Marty.createContainer(Legal, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/legal/Handler.js
 **/